import { VisitInterface } from '../interfaces';

import Axios from "../libraries/axios";

class VisitModel implements VisitInterface {
  [key: string]: any
  _id = '';
  originUrl = '';
  metadata = {};
  createdAt = new Date();
  updatedAt = new Date();

  constructor(props: VisitInterface) {
    if (props) {
      Object.assign(this, props);
    }
  }

  static async fetchAll<ReturnType>(
    params: any = {},
    config: any = {}
  ): Promise<ReturnType> {
    try {
      const { data } = await Axios.get('/api/visits', {
        params,
        ...config,
      });

      return data;
    } catch (e: any) {
      throw new Error(e);
    }
  }
}

export default VisitModel;
